
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.854 6.831h-7.443V5.24c0-.7-.51-1.239-1.21-1.239H3.346C2.644 4 2 4.538 2 5.24v13.189c0 1.228 1.071 2.192 2.298 2.192h15.556c1.227 0 2.146-.964 2.146-2.192V9.056c0-1.227-.919-2.225-2.146-2.225zm-4.073 7.237l-3.647 3.022c-.16.132-.362-.033-.362-.298v-1.285H8.71c-.26 0-.5-.309-.5-.682V12.66c0-.373.24-.715.5-.715h3.062v-1.252c0-.264.203-.43.362-.297l3.645 3.021c.174.145.176.506.002.65z","fill":"#282E3E"}})])
          )
        }
      }
    